export function MetricCard({
	label,
	value,
	detail,
	tone = "neutral",
}: {
	label: string;
	value: string;
	detail: string;
	tone?: "neutral" | "attention" | "success";
}) {
	return (
		<div className="rounded-2xl border border-stone-200 bg-white px-5 py-4 shadow-sm">
			<p className="text-xs font-medium text-stone-500">{label}</p>
			<p
				className={`mt-1 text-2xl font-semibold tracking-[-0.03em] ${
					tone === "attention"
						? "text-amber-700"
						: tone === "success"
							? "text-emerald-800"
							: "text-stone-950"
				}`}
			>
				{value}
			</p>
			<p className="mt-1 text-xs text-stone-500">{detail}</p>
		</div>
	);
}
